export default __webpack_public_path__ + "static/media/Finish.90f2b910.mp3";